import { render } from "./CustomizedContent.vue?vue&type=template&id=7f76a022"
import script from "./CustomizedContent.vue?vue&type=script&lang=js"
export * from "./CustomizedContent.vue?vue&type=script&lang=js"

import "./CustomizedContent.vue?vue&type=style&index=0&id=7f76a022&lang=css"
script.render = render

export default script